import { FunctionCategories, FunctionSubCategories } from '@makyoapp/makyo-common'

export type CategoryState = {
  cat: FunctionCategories | 'all' | 'favorite'
  subCat?: FunctionSubCategories | 'all'
}

export enum FunctionDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
